import { z } from 'zod';
import { languageSchema, membershipStatusSchema, roleSchema } from './role';

export const sessionUserSchema = z.object({
  id: z.uuid(),
  email: z.string(),
  name: z.string().nullable(),
  isSuperadmin: z.boolean(),
});

export type SessionUser = z.infer<typeof sessionUserSchema>;

// One row per venue the user may work in; viaPlatform means no membership row.
export const sessionMembershipSchema = z.object({
  venueId: z.uuid(),
  venueName: z.string(),
  venueSlug: z.string(),
  spotKind: z.string(),
  role: roleSchema,
  status: membershipStatusSchema,
  viaPlatform: z.boolean(),
});

export type SessionMembership = z.infer<typeof sessionMembershipSchema>;

export const sessionResponseSchema = z.object({
  user: sessionUserSchema,
  memberships: z.array(sessionMembershipSchema),
});

export type SessionResponse = z.infer<typeof sessionResponseSchema>;

// Asked before anyone is signed in; the MVP opens the google door only.
export const authMethodsSchema = z.object({
  googleEnabled: z.boolean(),
  magicLinkEnabled: z.boolean(),
});

export type AuthMethods = z.infer<typeof authMethodsSchema>;

// The language the person asking is reading the app in. No venue is chosen at
// this point (§5), so their own screen is the only thing that can decide it.
export const magicLinkRequestSchema = z.object({
  email: z.email(),
  language: languageSchema.optional(),
});

export type MagicLinkRequest = z.infer<typeof magicLinkRequestSchema>;
